import { BillSessionFile } from './index';

export class BillSession {
	public sessionId: string;
	public sessionName: string;
	public userId: string;
	public status: string;
	public files: BillSessionFile[];
	public totalFiles: number;
	public successFiles: number;
	public errorFiles: number;
	public s3Path?: string;
	public updatedAt?: string | Date;
	public createdAt?: string | Date;
	public result: {
		customerName?: string;
		statementDate?: string;
		commodity?: string;
		unit?: string;
		issuer?: string;
	};

	public cursor?: string;

	constructor(billSession?: BillSession) {
		Object.assign(this, billSession);
	}
}
